import {apiLogin, apiGetInfo, WeChatOAuth, UnionPayOAuth} from '../../api/api';
import Cookies from 'js-cookie';

import {
  UPDATE_USERINFO,
  UPDATE_HEAD,
  UPDATE_LOADING,
  UPDATE_FOOTER,
  UPDATE_PAGE_TITLE,
  UPDATE_TOKEN,
  UPDATE_ROLES,
  UPDATE_PHONE,
  UPDATE_COOPER,
  UPDATE_FEEDBACK,
  UPDATE_ACTIVITY,
  UPDATE_OPENID
} from './consts'

// COOKIES 过期时间
let inFifteenMinutes = new Date(new Date().getTime() + 20 * 60 * 60 * 1000);
// let inFifteenMinutes = new Date(new Date().getTime() + 20 * 1000);
const cookiesExpire = {expires:inFifteenMinutes};
//const cookiesExpire = 0;
// const cookiesExpire = 15 * 2;

const module = {
  state: {
    // 页头、加载框、页脚、页面标题设置
    headShow: Cookies.get(UPDATE_HEAD) == "true" ? true : false,
    loading: Cookies.get(UPDATE_LOADING) == "true" ? true : false,
    footerShow: Cookies.get(UPDATE_FOOTER) == "true" ? true : false,
    pageTitle: '首页',

    token: Cookies.get(UPDATE_TOKEN), // 登录授权
    uid: undefined,                   // 登录用户UID
    name: '',                         // 登录用户名
    avatar: '',                       // 登录用户头像
    roles: JSON.parse(Cookies.get(UPDATE_ROLES)||'[]'), // 登录用户权限（不同权限走不同的路由：通用渠道商、活动渠道商、微信渠道商、我们页面对方收款、对方页面我们收款）
    phoneShow: Cookies.get(UPDATE_PHONE) == "true" ? true : false,
    cooperShow: Cookies.get(UPDATE_COOPER) == "true" ? true : false,
    feedbackShow: Cookies.get(UPDATE_FEEDBACK) == "true" ? true : false,
    activityData: [],
    openId: Cookies.get(UPDATE_OPENID), // 云闪付用户唯一标识
  },
  mutations: {
    /*head*/
    [UPDATE_HEAD](state, type) {
      state.headShow = type;
    },
    /*loading*/
    [UPDATE_LOADING](state, type) {
      state.loading = type;
    },
    /*footer*/
    [UPDATE_FOOTER](state, type) {
      state.footerShow = type;
    },
    /*title*/
    [UPDATE_PAGE_TITLE](state, type) {
      state.pageTitle = type;
    },
    /*token*/
    [UPDATE_TOKEN](state, type) {
      state.token = type;
    },
    /*roles*/
    [UPDATE_ROLES](state, type) {
      state.roles = type;
    },
    /*phone*/
    [UPDATE_PHONE](state, type) {
      state.phoneShow = type;
    },
    /*COOPER*/
    [UPDATE_COOPER](state, type) {
      state.cooperShow = type;
    },
    /*FEEDBACK*/
    [UPDATE_FEEDBACK](state, type) {
      state.feedbackShow = type;
    },
    /*UPDATE_ACTIVITY*/
    [UPDATE_ACTIVITY](state,type){
      state.activityData = type;
    },
  /*openId*/
    [UPDATE_OPENID](state, type) {
      state.openId = type;
    }
  },
  actions: {
    // 登录
    Login({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        apiLogin(userInfo).then(response => {
          const res = response.data;
          console.log('---------------',response.data);

          if (res.code !== 1){
            resolve(res);
            return;
          }

          // 保存授权过的信息
          Cookies.set(UPDATE_USERINFO, JSON.stringify(userInfo));
          console.log(res.data.token)
          // 当前登录授权的登录token
          Cookies.set(UPDATE_TOKEN, res.data.token, {expires: new Date(new Date().getTime() + 20 * 60 * 60 * 1000)});
          commit(UPDATE_TOKEN, res.data.token);
          //当前登录授权的登录openId
          Cookies.set(UPDATE_OPENID, res.data.openId);
          commit(UPDATE_OPENID, res.data.openId);
          // 设置权限
          Cookies.set(UPDATE_ROLES, JSON.stringify(res.data.role));
          commit(UPDATE_ROLES, res.data.role);

          if (res.data.dealerParamInfoPos) {
            res.data.dealerParamInfoPos.forEach(item => {
              if (item.dealerKey === 'titileSwitch') {

                let value = item.dealerValue == "1" ? true : false;
                // 设置HEAD开关
                Cookies.set(UPDATE_HEAD, value, cookiesExpire);
                commit(UPDATE_HEAD, value);
              } else if (item.dealerKey === 'moblieSwitch') {

                let value = item.dealerValue == "1" ? true : false;
                // 设置手机验证开关
                Cookies.set(UPDATE_PHONE, value, cookiesExpire);
                commit(UPDATE_PHONE, value);
              } else if (item.dealerKey === 'cooperSwitch') {

                let value = item.dealerValue == "1" ? true : false;
                // 设置合作开关
                Cookies.set(UPDATE_COOPER, value, cookiesExpire);
                commit(UPDATE_COOPER, value);
              } else if (item.dealerKey === 'feedbackSwitch') {

                let value = item.dealerValue == "1" ? true : false;
                // 设置反馈开关
                Cookies.set(UPDATE_FEEDBACK, value, cookiesExpire);
                commit(UPDATE_FEEDBACK, value);
              }
            });
          }

          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        console.log("登出")
        commit(UPDATE_TOKEN, '');
        Cookies.remove(UPDATE_TOKEN);
        commit(UPDATE_ROLES, []);
        Cookies.remove(UPDATE_ROLES);
        commit(UPDATE_OPENID, '');
        Cookies.remove(UPDATE_OPENID);
        resolve();
      });
    },

    // 获取用户信息（重点是获取当前登录的权限）
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {

        apiGetInfo(state.token).then(response => {
          const res = response.data;
          // 设置权限
          commit(UPDATE_ROLES, res.data.roles);

          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    WeChatOAuth({commit, state}){
      return new Promise((resolve, reject) => {
        WeChatOAuth().then(response => {
          let res = response.data;
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    
    //云闪付获取授权
    UnionPayOAuth({commit, state}){
      return new Promise((resolve, reject) => {
        UnionPayOAuth().then(response => {
          let res = response.data;
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
  }
};

export default module



// WEBPACK FOOTER //
// ./src/store/modules/module.js